import { create } from 'zustand';

const useBlogStore = create((set) => ({
  blogs: [],
  currentBlog: null,
  isLoading: false,
  error: null,

  setBlogs: (blogs) => set({
    blogs,
    isLoading: false,
    error: null
  }),

  setCurrentBlog: (blog) => set({
    currentBlog: blog,
    isLoading: false,
    error: null
  }),

  updateBlog: (updates) => set((state) => ({
    blogs: state.blogs.map(blog => 
      blog.id === updates.id ? { ...blog, ...updates } : blog
    ),
    currentBlog: state.currentBlog?.id === updates.id 
      ? { ...state.currentBlog, ...updates }
      : state.currentBlog,
    isLoading: false,
    error: null
  })),

  addBlog: (blog) => set((state) => ({
    blogs: [...state.blogs, blog],
    isLoading: false,
    error: null
  })),

  removeBlog: (blogId) => set((state) => ({
    blogs: state.blogs.filter(blog => blog.id !== blogId),
    currentBlog: state.currentBlog?.id === blogId ? null : state.currentBlog,
    isLoading: false,
    error: null
  })),

  setError: (error) => set({
    error,
    isLoading: false
  }),

  setLoading: (isLoading) => set({ isLoading }),

  clearBlogs: () => set({
    blogs: [],
    currentBlog: null,
    isLoading: false,
    error: null
  }),
}));

export default useBlogStore;